/** PURE_IMPORTS_START tslib PURE_IMPORTS_END */
import * as tslib_1 from "tslib";
var ArgumentOutOfRangeError = /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var _this = _super.call(this, 'argument out of range') || this;
        _this.name = 'ArgumentOutOfRangeError';
        Object.setPrototypeOf(_this, ArgumentOutOfRangeError.prototype);
        return _this;
    }
    return ArgumentOutOfRangeError;
}(Error));
export { ArgumentOutOfRangeError };
//# sourceMappingURL=ArgumentOutOfRangeError.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/ArgumentOutOfRangeError.js
// module id = 294
// module chunks = 2